<template>
    <div class="stack-item tracking">
        <h3>{{ $t('SHARE_ORDER.path.tracking_number')}}</h3>
        <h4>{{ trackingNumber }}</h4>
    </div>
</template>

<script>
export default {
  name: 'TrackingNumber',
  props: {
      trackingNumber: String,
  }
}
</script>

<style lang="scss" scoped>
    .tracking {
        padding: .6rem 0;

        h3 {
            font-size: 14px;
            font-weight: 400;
            white-space: nowrap;
        }

        h4 {
            font-size: 15px;
            font-weight: 600;
        }
    }
</style>
